var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.7709 7.53594H6.63645L9.31476 0.301447C9.33794 0.232954 9.3266 0.157886 9.28373 0.0988579C9.24103 0.0396696 9.17198 0.00309891 9.09708 0.000212179H3.35814C3.24889 -0.00427889 3.15047 0.0629278 3.11895 0.163504L0.0103099 10.0125C-0.0122078 10.0839 0.00263653 10.1613 0.0501741 10.2202C0.0977126 10.2792 0.171939 10.3123 0.2495 10.3091H4.05151L2.42073 18.7278C2.40005 18.8342 2.45927 18.9399 2.56285 18.9819C2.66626 19.0239 2.78636 18.9909 2.85107 18.9027L10.962 7.89036C11.0084 7.82107 11.0126 7.73317 10.973 7.66002C10.9337 7.58688 10.8564 7.53956 10.7707 7.53619L10.7709 7.53594Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.aefcf3d5d61ce9ab5cda5a238f708e85.svg";
export { ForwardRef as ReactComponent };